import { createSlice } from '@reduxjs/toolkit';
import { io } from 'socket.io-client';

/**
 * {
 * message: string,
 * id: string,
 * progress: number | undefined,
 * title: string | undefined,
 * timeout: number
 * cancellable: boolean,
 * }
 */

export const userSlice = createSlice({
    name: 'user',
    initialState: {
        user: undefined,
        loaded: false,
        logoutURL: '',
        featureFlags: {
            cloud: process.env.CLOUD_FEATURE_FLAG === '1',
            micropython: process.env.MICROPYTHON_FEATURE_FLAG === '1',
            zephyr: process.env.ZEPHYR_FEATURE_FLAG === '1',
            customFeature: process.env.CUSTOM_FEATURE_FLAG === '1',
        },
        preferences: {
            panels: {
                left: {
                    initSize: 370,
                    size: null,
                },
                right: {
                    initSize: 330,
                    size: null,
                },
                debug: {
                    initSize: 350,
                    size: null,
                },
                codePreview: {
                    initSize: 250,
                    size: null,
                },
                codePreviewHighlights: {
                    initSize: 150,
                    size: null,
                },
                boardDesignerLeft: {
                    initSize: 400,
                    size: null,
                },
            },
        },
    },
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
        },
        setPanelPreference: (state, action) => {
            state.preferences = {
                ...state.preferences,
                panels: {
                    ...state.preferences.panels,
                    [action.payload.name]: action.payload.value,
                },
            };
        },
        loadSession: (state, action) => {
            return state;
        },
        setLoaded: (state, action) => {
            state.loaded = action.payload;
        },
        setLogoutURL: (state, action) => {
            state.logoutURL = action.payload;
        },
        setFeatureFlag: (state, action) => {
            return {
                ...state,
                featureFlags: {
                    ...state.featureFlags,
                    [action.payload.name]: action.payload.value,
                },
            };
        },
        logout: (state, action) => {
            return state;
        },
    },
});

// Action creators are generated for each case reducer function
export const {
    setUser,
    setPreference,
    setPanelPreference,
    loadSession,
    setLoaded,
    setLogoutURL,
    setFeatureFlag,
    logout,
} = userSlice.actions;

export default userSlice.reducer;
